import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';

// Providers
import { AuthProvider } from './contexts/AuthContext';
import { RISearchProvider } from './contexts/RISearchContext';
import { RISViewerProvider } from './contexts/RISViewerContext';

// Pages
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import RISAssistant from './pages/RISAssistant';
import SSOLanding from './components/SSOLanding';

// Components
import RISViewerModal from './components/RISViewerModal';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';

// Admin is now a separate application at risearchadmin.aidea.tirol

function App() {
  return (
    <AuthProvider>
      <RISearchProvider>
        <RISViewerProvider>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />

              {/* SSO entry point */}
              <Route path="/sso" element={<SSOLanding />} />

              {/* Protected routes with persistent AppLayout */}
              <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/ris" element={<><RISAssistant /><RISViewerModal /></>} />
              </Route>

              {/* Legacy redirect */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
          <Toaster position="top-right" richColors />
        </RISViewerProvider>
      </RISearchProvider>
    </AuthProvider>
  );
}

export default App;
